export const crashLoggerUrl: string = `https://crash-logger-dot-cms-headless-gae.ew.r.appspot.com/`;
